// extracted by mini-css-extract-plugin
export default {"AddScreeningButton":"PurchaseHistory_AddScreeningButton__tNIDR"};